import React from 'react';
import { formatPercent } from '../utils/narrative';

const DIMENSIONS = [
  { key: 'exampleDensity', label: 'Examples' },
  { key: 'stepGranularity', label: 'Pace' },
  { key: 'abstraction', label: 'Depth' },
  { key: 'instructionStyle', label: 'Style' },
  { key: 'tone', label: 'Tone' },
];

// The profile that shapes generated lessons, stated in words first and only
// then as the five dimension meters behind it.
export default function LearningStyleCard({ data }) {
  const profile = data?.profile;
  if (!profile) return null;

  const confidence = data?.profileConfidence;
  const calibrated = formatPercent(confidence?.progress);
  const descriptions = data?.dimensionDescriptions || {};

  return (
    <section className="ins-style">
      <div style={{ flex: 1, minWidth: 0 }}>
        <p className="ins-eyebrow" style={{ marginBottom: 6 }}>
          Learning style profile
        </p>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
          <h2
            style={{
              margin: 0,
              fontSize: 17,
              fontWeight: 600,
              letterSpacing: '-0.014em',
              color: 'var(--text-primary)',
            }}
          >
            {data.archetypeLabel || 'Still taking shape'}
          </h2>
          {calibrated && (
            <span style={{ fontSize: 12, color: 'var(--text-tertiary)' }}>{calibrated} calibrated</span>
          )}
        </div>
        <p style={{ margin: 0, maxWidth: 420, fontSize: 13, lineHeight: 1.55, color: 'var(--text-secondary)' }}>
          {data.archetypeDescription ||
            'Complete a few more quizzes and Graspd will describe how you like to be taught.'}
        </p>
      </div>

      <div className="ins-style-dims">
        {DIMENSIONS.map((dimension) => {
          const value = profile[dimension.key];
          const percent = Math.round(Math.min(Math.max(value ?? 0, 0), 1) * 100);
          return (
            <div key={dimension.key} style={{ display: 'flex', alignItems: 'center', gap: 10 }} title={descriptions[dimension.key] || undefined}>
              <span style={{ width: 74, flex: 'none', fontSize: 12, color: 'var(--text-secondary)' }}>
                {dimension.label}
              </span>
              <div className="ins-meter-track" style={{ flex: 1, height: 6 }}>
                <div
                  className="ins-meter-fill"
                  style={{ width: `${percent}%`, background: 'var(--text-secondary)' }}
                />
              </div>
              <span
                style={{
                  width: 26,
                  flex: 'none',
                  textAlign: 'right',
                  fontSize: 11.5,
                  fontWeight: 500,
                  fontFamily: 'var(--font-mono)',
                  color: 'var(--text-tertiary)',
                }}
              >
                {percent}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
